import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      const token = localStorage.getItem('token');

      if (token !== null && token !== 'undefined' && token !== '') {
        console.log('AuthGuard: AUTHORIZED');
        return true;
      }

      console.log('AuthGuard: Not authorized');

      this.router.navigate(['/login']);

      return false;
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/cognito/auth.guard.ts